import { render, staticRenderFns } from "./lawsuit-follow-evaluate.vue?vue&type=template&id=58e08a25&scoped=true"
import script from "./lawsuit-follow-evaluate.vue?vue&type=script&lang=ts"
export * from "./lawsuit-follow-evaluate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e08a25",
  null
  
)

export default component.exports